import { type ThemeState, themeStringToObject } from '@atlaskit/tokens';

import { DEFAULT_THEME } from './constants';

export const updateThemeObjectWithDefaultValues = (
	themeObject: Partial<ThemeState>,
): Partial<ThemeState> =>
({
	...DEFAULT_THEME,
	...themeObject,
});

export const updateThemeWithDefaultValues = (
	themeString: string,
): Partial<ThemeState> => updateThemeObjectWithDefaultValues(themeStringToObject(themeString));
